import { NumberFormatType } from "@/core/types";
import { AppConfig } from "@/infrastructure/services/config";

const appConfig = AppConfig.getInstance();
const DEFAULT_DATE_FORMAT = appConfig.DEFAULT_DATE_FORMAT;
const DEFAULT_DATE_FORMAT_WITH_TIME = appConfig.DEFAULT_DATE_FORMAT_WITH_TIME;
const DEFAULT_TILE_FORMA = appConfig.DEFAULT_TIME_FORMAT;
const DEFAULT_NUMBER_FORMAT = appConfig.DEFAULT_NUMBER_FORMAT as NumberFormatType;
const DEFAULT_FILTER_CHECK_DATE_RANGE = appConfig.DEFAULT_FILTER_CHECK_DATE_RANGE;
export class WorkSpaceSettings {
  private readonly _primaryColor?: string | null;
  private readonly _secondaryColor?: string | null;
  private readonly _displayDateFormat?: string | null;
  private readonly _displayDateFormatWithTime?: string | null;
  private readonly _displayTimeFormat?: string | null;
  private readonly _displayNumberFormat?: NumberFormatType | null;
  private readonly _defaultCheckDateRange?: number | null;

  constructor(props?: {
    displayDateFormat?: string | null;
    displayDateFormatWithTime?: string | null;
    displayTimeFormat?: string | null;
    displayNumberFormat?: NumberFormatType | null;
    defaultCheckDateRange?: number | null;
    primaryColor?: string | null;
    secondaryColor?: string | null;
  }) {
    if (props) {
      this._primaryColor = props.primaryColor;
      this._secondaryColor = props.secondaryColor;
      this._displayDateFormat = props.displayDateFormat;
      this._displayDateFormatWithTime = props.displayDateFormatWithTime;
      this._displayTimeFormat = props.displayTimeFormat;
      this._displayNumberFormat = props.displayNumberFormat;
      this._defaultCheckDateRange = props.defaultCheckDateRange;
    }
  }

  get primaryColor(): string | null {
    return this._primaryColor ?? null;
  }

  get secondaryColor(): string | null {
    return this._secondaryColor ?? null;
  }

  get displayDateFormat(): string {
    return this._displayDateFormat ?? DEFAULT_DATE_FORMAT;
  }

  get displayDateFormatWithTime(): string {
    return this._displayDateFormatWithTime ?? DEFAULT_DATE_FORMAT_WITH_TIME;
  }

  get displayTimeFormat(): string {
    return this._displayTimeFormat ?? DEFAULT_TILE_FORMA;
  }

  get displayNumberFormat(): NumberFormatType {
    return this._displayNumberFormat ?? DEFAULT_NUMBER_FORMAT;
  }

  get defaultFilterCheckDateRange(): number {
    return this._defaultCheckDateRange ?? DEFAULT_FILTER_CHECK_DATE_RANGE;
  }
}
